module.exports = __webpack_public_path__ + "static/img/guest10.aacf1c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest10.png
// module id = h2C9
// module chunks = 0